var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCompletedtask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_9004773_tick_check_mark_accept_icon",
    "data-name": "9004773_tick_check_mark_accept_icon",
    d: "M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm5.707,8.707-7,7a1,1,0,0,1-1.414,0l-3-3a1,1,0,1,1,1.414-1.414L10,14.586l6.293-6.293a1,1,0,1,1,1.414,1.414Z",
    transform: "translate(-1 -1)",
    fill: "#3bb64a"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedtask);
export default __webpack_public_path__ + "static/media/completedtask.59f0be35ad68151eff5d43186e246b1f.svg";
export { ForwardRef as ReactComponent };